import { Student, StudentFormData } from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"

const baseApi = createCrudApi<Student, StudentFormData, StudentFormData>(
  "/students"
)

// 学生API
const studentApi = {
  // 查询所有（支持分页参数）
  async getList(params?: {
    page?: number
    pageSize?: number
  }): Promise<PaginationResult<Student>> {
    return baseApi.list(params)
  },

  // ID查询
  async getById(id: ID): Promise<Student | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: StudentFormData): Promise<void> {
    const payload = {
      name: data.name,
      status: data.status,
      birthday: data.birthday,
      note: data.note,
    }
    await baseApi.create(payload)
  },

  // 更新
  async update(id: ID, data: StudentFormData): Promise<void> {
    const payload = {
      name: data.name,
      status: data.status,
      birthday: data.birthday,
      note: data.note,
    }
    await baseApi.update(id, payload)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default studentApi
